module.exports = {
      id: "icon-tablet-usage",
      viewBox: "0 0 24 24",
      url: "/img/" + "24363fc9336203101fb174cc768dfb0f.svg#icon-tablet",
      toString: function () {
        return this.url;
      }
    }